export default () => {
    return {
        getQueryParam: function(paramId) {
            var val = new URL(window.location).searchParams.get(paramId)
            return val && val !== '' ? val : null        
        }
    }
}